import { GraphAndListTemperature } from "./GraphAndListTemperature";
export default GraphAndListTemperature;
